/**
 * Есть ли на платформе хоть один конкурс.
 *
 * Пункт «Конкурсы» появляется в меню только когда конкурс создан: пустой
 * раздел в меню — это обещание, которого платформа не сдержала, и человек
 * заходит туда один раз.
 *
 * Ответ кэшируется на всё время работы приложения: это один запрос на загрузку
 * страницы, а не на каждый переход между экранами, иначе шапка дёргает сервер
 * при каждой навигации.
 */
import { useEffect, useState } from 'react';

import { api } from './api';

let cache: boolean | null = null;
let inflight: Promise<boolean> | null = null;

function load(): Promise<boolean> {
  if (cache !== null) return Promise.resolve(cache);
  inflight ??= api
    .contests()
    .then((r) => r.contests.length > 0)
    .catch(() => false)
    .then((has) => {
      cache = has;
      inflight = null;
      return has;
    });
  return inflight;
}

export function useHasContests(): boolean {
  const [has, setHas] = useState(cache ?? false);
  useEffect(() => {
    let alive = true;
    void load().then((v) => alive && setHas(v));
    return () => {
      alive = false;
    };
  }, []);
  return has;
}

/** Сбросить кэш — нужно, когда конкурс только что появился. */
export function forgetContests() {
  cache = null;
  inflight = null;
}
